import {
  Component,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ConsentComplete } from '../../models/consent-completed.model';
import { RegisterService } from '../../services/register.service';
import { CONSTANTS } from '../../constants';
import { MatIconModule } from "@angular/material/icon";
import {
  TranslateModule,
} from '@ngx-translate/core';

@Component({
  selector: 'app-completed-consent',
  templateUrl: './completed-consent.component.html',
  styleUrls: ['./completed-consent.component.css'],
})
export class CompletedConsentComponent implements OnInit, OnDestroy {
  studentPortalNavRoute = '/profile';
  backofficeProfileRoute = '/review/profile';
  registerFormNavRoute = '/register';
  errorState = false;
  isStudentPortal: string | undefined;
  isProfileBackoffice: string | undefined;
  event = '';
  envelopeId = '';
  locationId = '';
  studentId = '';
  consentId = '';
  encryptedData = '';
  orgCode = '';
  studentConsentId = '';
  consentData: ConsentComplete = new ConsentComplete();
  index: string;
  subscriptions: Subscription[] = [];

  constructor(private _regService: RegisterService, private _router: Router) {}

  ngOnInit(): void {
    this.setVariablesFromUrlParams();

    if (this.event === 'signing_complete' && this.isProfileBackoffice) {
      this.updateStudentConsentStatus();
    } else if (this.event === 'signing_complete' && this.isStudentPortal) {
      this.updateStudentConsentStatus();
    } else if (
      this.event === 'signing_complete' &&
      !this.isProfileBackoffice &&
      !this.isStudentPortal
    ) {
      this.createCompletedStudentConsent();
    } else {
      this.errorState = true;
    }
  }
  updateStudentConsentStatus() {
    this._regService
      .updateStudentConsentStatus(this.consentData)
      .subscribe(() => {
        if (this.isStudentPortal) {
          this._router.navigate([`${this.studentPortalNavRoute}`]);
        } else {
          this._router.navigate([
            `${this.backofficeProfileRoute}/${this.studentId}`,
          ]);
        }
      });
  }

  createCompletedStudentConsent() {
    const splitIds = this.consentId.split(',').map(i => Number(i));;
    this.consentData.consentIds = splitIds;
    this.subscriptions.push(
      this._regService
        .createCompletedStudentConsent(this.consentData)
        .subscribe((val: ConsentComplete) => {
          localStorage.setItem(
            CONSTANTS.ENVELOPE_STORAGE_KEY,
            JSON.stringify(this.envelopeId)
          );
          this._router.navigate([`${this.registerFormNavRoute}`], {
            queryParams: {
              location: this.locationId,
              index: this.index,
              data: this.encryptedData
            },
          });
        })
    );
  }

  setVariablesFromUrlParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    this.event = urlSearchParams.get('event');
    this.envelopeId = urlSearchParams.get('eid');
    this.studentId = urlSearchParams.get('sid');
    this.consentId = urlSearchParams.get('cid');
    this.studentConsentId = urlSearchParams.get('scid');
    this.orgCode = urlSearchParams.get('orgCode');
    this.encryptedData = urlSearchParams.get('encryptedData');
    this.locationId = urlSearchParams.get('location');
    this.index = urlSearchParams.get('index');
    this.isStudentPortal = urlSearchParams.get('studentPortal');
    this.isProfileBackoffice = urlSearchParams.get('profileBackoffice');
    this.consentData.envelopeId = this.envelopeId;
    this.consentData.consentId = Number(this.consentId);
    this.consentData.studentId = Number(this.studentId);
    this.consentData.studentConsentId = Number(this.studentConsentId);
    this.consentData.locationId = Number(this.locationId);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  forceNavigation() {
    if (this.isStudentPortal) {
      this._router.navigate([`${this.studentPortalNavRoute}`]);
    } else if (this.isProfileBackoffice) {
      this._router.navigate([
        `${this.backofficeProfileRoute}/${this.studentId}`,
      ]);
    } else {
      this._router.navigate([`${this.registerFormNavRoute}`], {
        queryParams: { location: this.locationId, index: this.index, data: this.encryptedData },
      });
    }
  }
}
